/** Starts with 00 so that it sorts first. */
export const DEFAULT_COLLECTION_ID = "00default";
export const DEFAULT_COLLECTION_NAME = "Read later";
export const MAX_COLLECTION_NAME_LENGTH = 50;
export const MAX_COLLECTIONS_PER_USER = 10;
export const MAX_ARTICLES_PER_COLLECTION = 100;

/** Key of an article in the read set and in the bookmarked map: "authorAlias:articleId". */
export const toArticleKey = (authorAlias: string, articleId: string): string => `${authorAlias}:${articleId}`;
